import { msgTypes } from 'constants/msgTypes';
import React from 'react'
import { RequestQuotesService } from 'services/menu/requestQuotesOverviewService/RequestQuotesOverviewService';
import ApiUrl from 'services/shared/ApiUrl';

const DisplayParticularQuoteAsDrawer = ({ selectedQuotes, setOpen }) => {

    function convertHTMLToPlain(html) {
        var tempDivElement = document.createElement("div");
        tempDivElement.innerHTML = html;
        return tempDivElement.textContent || tempDivElement.innerText || "";
    }

    const readQuotes = async (row) => {
        const response = await RequestQuotesService.markAsReadQuotes(row.requestId);
        if (response.statusMsg === msgTypes.SUCCESS.msg) {
            setOpen(false)
        }
    }

    return (
        <>
            <div className='list-popup'>
                <ul className="list-group">
                    <li className="list-group-item border-0 d-flex p-4 bg-gray-100 border-radius-lg">
                        <div className="d-flex flex-column">
                            {/* <h6 className="mb-3 text-sm">Invoice</h6> */}
                            <span className="mb-2 text-xs">From : <span className="text-dark font-weight-bold ms-2">{selectedQuotes.from}</span></span>
                            <span className="mb-2 text-xs">To : <span className="text-dark font-weight-bold ms-2">{selectedQuotes.to}</span></span>
                            <span className="mb-2 text-xs">CC : <span className="text-dark ms-2 font-weight-bold">{selectedQuotes.requestCc}</span></span>
                            <span className="mb-2 text-xs">BCC :<span className="text-dark ms-2 font-weight-bold">{selectedQuotes.requestBcc}</span></span>
                            <span className="mb-2 text-xs">Subject :<span className="text-dark ms-2 font-weight-bold">{selectedQuotes.requestSubject}</span></span>
                            <span className="mb-2 text-xs">Message :<span className="text-dark ms-2 font-weight-bold">{convertHTMLToPlain(selectedQuotes.requestMessage)}</span></span>
                            <span className="mb-2 text-xs">Attachments :<span className="text-dark ms-2 font-weight-bold">
                                {selectedQuotes?.requestFile?.map((attachment, index) => {
                                    return (
                                        <a href={ApiUrl.fileBaseUrl + attachment} target='_blank'>
                                            <div key={index}>
                                                Attachment{index + 1}
                                            </div>
                                        </a>
                                    )
                                })}
                            </span></span>

                            {selectedQuotes.unreadMessageNo === false && (
                            <div className='row mt-3'>
                                <button className='btn btn-submit text-white w-100' onClick={() => { readQuotes(selectedQuotes) }}>Read</button>
                            </div>
                        )}

                        </div>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default DisplayParticularQuoteAsDrawer